import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Crown, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/", label: "Home" },
    { to: "/#services", label: "Services" },
    { to: "/#pricing", label: "Pricing" },
    { to: "/#gallery", label: "Gallery" },
    { to: "/#travel", label: "Travel" },
    { to: "/#contact", label: "Contact" },
  ];

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#050505]/80 border-b border-[#D4AF37]/10"
    >
      <div className="px-6 md:px-12 lg:px-24 py-5 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <Crown className="w-6 h-6 text-[#D4AF37] group-hover:rotate-12 transition-transform" />
          <span className="font-serif text-xl tracking-wide">
            <span className="text-white">Luxury</span>{" "}
            <span className="gold-gradient-text font-medium">Kingz</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.to}
              href={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm tracking-[0.2em] uppercase text-zinc-400 hover:text-[#D4AF37] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <Link to="/book" data-testid="navbar-book-now" className="lk-btn-primary text-xs">
            Book Now
          </Link>
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#D4AF37]/10 bg-[#050505] px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a key={l.to} href={l.to} onClick={() => setOpen(false)} className="text-sm tracking-[0.2em] uppercase text-zinc-300">
              {l.label}
            </a>
          ))}
          <Link to="/book" onClick={() => setOpen(false)} className="lk-btn-primary text-xs text-center">
            Book Now
          </Link>
        </div>
      )}
    </header>
  );
}
